import VueRouter from 'vue-router'
import { useUserStore } from '@/stores'
import routes from '@/routes'
import { $isLogin } from '@/helpers'
import { isMobile } from '@/utils'

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0, behavior: 'smooth' }
  },
})

// Router Guards
router.beforeEach(async (to, _form, next) => {
  // Set document title
  document.title = to?.meta?.title

  // Skip
  if (to.meta?.skipGuard) {
    next()
    return
  }

  // Global config
  // const configStore = useConfigStore()
  // try {
  //   await configStore.init()
  // }
  // catch (error) {
  //   next({ name: 'error', query: { error: JSON.stringify(error), redirect: window.encodeURIComponent(to.fullPath) } })
  // }

  // Requires Auth
  if (to.meta?.requiresAuth !== false && !$isLogin()) {
    next({ name: 'login', query: { r: window.encodeURIComponent(to.fullPath) } })
  }
  else {
    if ($isLogin()) {
      const userStore = useUserStore()
      try {
        await userStore.init()
        // 已登录且访问 add-order 时，若昵称为手机号则跳转到收集姓名
        if (to.name === 'add-order' && isMobile(userStore.$state.name)) {
          next({ name: 'collect-name', query: { r: 'add-order' } })
          return
        }
      }
      catch (error) {
        next({ name: 'error', query: { error: JSON.stringify(error), redirect: window.encodeURIComponent(to.fullPath) } })
        return
      }
    }
    next()
  }
})

export default router
